import React from 'react';
import BenefitSummaryComponent from './BenefitSummary.component';
import { BenefitSummaryEditorProps } from './BenefitSummary.types';
import { adaptBenefitSummaryEditorProps } from './BenefitSummary.adapter';
import './BenefitSummary.css';

/**
 * BenefitSummary 에디터 컴포넌트
 */
const BenefitSummaryEditor: React.FC<any> = (props) => {
  // 어댑터를 통해 props 변환
  const adaptedProps = adaptBenefitSummaryEditorProps(props);
  const { isSelected, isPreview, updateComponent, ...componentProps } = adaptedProps;

  // 선택 표시자와 핸들 스타일
  const selectionIndicatorStyle = {
    position: 'absolute' as const,
    top: -2,
    left: -2,
    right: -2,
    bottom: -2,
    border: '2px solid #3498db',
    borderRadius: 4,
    pointerEvents: 'none' as const,
    zIndex: 1
  };

  const resizeHandleStyle = {
    position: 'absolute' as const,
    width: 8,
    height: 8,
    backgroundColor: '#3498db',
    border: '1px solid white',
    borderRadius: '50%',
    zIndex: 10
  };

  // 미리보기 모드이거나 선택되지 않았으면 기본 컴포넌트만 렌더링
  if (isPreview || !isSelected) {
    return <BenefitSummaryComponent {...componentProps} />;
  }

  // 에디터 모드에서 선택된 상태 - 리사이즈/이동 핸들 표시
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* 실제 컴포넌트 */}
      <BenefitSummaryComponent {...componentProps} />

      {/* 선택 표시 */}
      <div style={selectionIndicatorStyle}></div>

      {/* 리사이즈 핸들 */}
      <div style={{ ...resizeHandleStyle, top: -4, left: -4, cursor: 'nw-resize' }} data-handle="nw"></div>
      <div style={{ ...resizeHandleStyle, top: -4, right: -4, cursor: 'ne-resize' }} data-handle="ne"></div>
      <div style={{ ...resizeHandleStyle, bottom: -4, left: -4, cursor: 'sw-resize' }} data-handle="sw"></div>
      <div style={{ ...resizeHandleStyle, bottom: -4, right: -4, cursor: 'se-resize' }} data-handle="se"></div>

      {/* 이동 핸들 */}
      <div style={{
        position: 'absolute',
        top: -16,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 20,
        height: 10,
        backgroundColor: '#3498db',
        borderRadius: '3px 3px 0 0',
        cursor: 'move'
      }}></div>
    </div>
  );
};

export default BenefitSummaryEditor; 